module.exports = __webpack_public_path__ + "static/media/sink-state-3.a26f5fea.wav";